'use strict';

var React = require('react');

var SvgPintrestMinor = function SvgPintrestMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 8.347c0-2.787 2.153-5.347 6.208-5.347 3.26 0 5.792 2.184 5.792 5.103 0 3.045-2.042 5.495-4.875 5.495-.953 0-1.847-.465-2.153-1.014l-.586 2.1c-.212.767-.784 1.73-1.168 2.316a9.717 9.717 0 0 1-.643-.22c-.082-.699-.155-1.768.034-2.528.17-.69 1.101-4.392 1.101-4.392s-.28-.53-.28-1.311c0-1.23.756-2.146 1.699-2.146.802 0 1.188.566 1.188 1.244 0 .485-.21 1.123-.43 1.795-.124.378-.252.768-.348 1.147-.221.88.47 1.597 1.391 1.597 1.67 0 2.954-1.656 2.954-4.046 0-2.115-1.616-3.595-3.924-3.595-2.673 0-4.242 1.886-4.242 3.835 0 .76.31 1.573.7 2.016.076.088.087.164.064.254-.043.169-.118.456-.178.683l-.083.319c-.04.162-.136.195-.314.118-1.173-.514-1.907-2.127-1.907-3.423Z"
  }));
};
SvgPintrestMinor.displayName = "PintrestMinor";

exports.SvgPintrestMinor = SvgPintrestMinor;
